<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDeviceType',
})
</script>
<template>
	<el-select v-model="model" check-strictly style="width: 100%" :clearable="clearable" :placeholder="placeholder" :disabled="disabled">
		<!-- <el-option v-for="i of storeSys.device_type" :key="i" :value="i[props.value ?? 'value']" :label="i[props.label ?? 'label']" /> -->
	</el-select>
</template>

<script setup lang="ts" name="MaDeviceType">
import { ref, onMounted } from 'vue'

import { sysStore } from '@/store/modules/sys'
const storeSys = sysStore()
defineProps({
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	},
	props: {
		type: Object,
		required: false,
		default: () => {}
	}
})

const model = defineModel<number | string>()
const dataList = ref([])

onMounted(() => {})
</script>
